import React from 'react';
import {Table} from '../../../data-table/Table';
import { CSVLink } from "react-csv";
import { Link } from "react-router-dom";
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DownloadIcon from '@mui/icons-material/Download';
import Tooltip from '@mui/material/Tooltip';
import "../../components/custom_material_ui_like.css"


const SummaryInserted = (props) => {
    return(
        <div className={"mainContent"}>
            <Typography variant={"h5"} align={"center"}> {props.location.title} </Typography>
            <Typography variant={"h6"} align={"center"}>Summary of your Submission</Typography>
            <Grid container rowSpacing={1}>
                <Grid item xs={6} style={{ display: "flex", justifyContent: "flex-start" }}>
                        <CSVLink className="custom_mui_button_ligth" 
                             data={props.location.tableContents} 
                             filename={props.location.filename}>
                                
                                <Grid container direction="row" alignItems="center">
                                    <Grid item>
                                        <DownloadIcon />
                                    </Grid>
                                    <Grid item>
                                           DOWNLOAD AS CSV 
                                    </Grid>
                                </Grid>
                                
                        </CSVLink>     
                </Grid>
                <Grid item xs={6} style={{ display: "flex", justifyContent: "flex-end" }}>
                    { props.location.nextPage !== "" ?
                            <Link 
                                className="custom_mui_button_orange"
                                role="button"
                                to={{pathname:props.location.nextPage, contents:props.location.tableContents}}
                            > 
                                <Grid container direction="row" alignItems="center">
                                    <Grid item>
                                        <Tooltip title={props.location.tooltip}>
                                            <ArrowForwardIcon />  
                                        </Tooltip>
                                    </Grid> 
                                    <Grid item>
                                        <Tooltip title={props.location.tooltip}>
                                            <div> {props.location.nextPageLabel} </div>
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                            </Link>              
                      :
                        null
                    }  
                </Grid>
            </Grid>
            <Table tableContents = {props.location.tableContents} />
        </div>
    );
}

export default SummaryInserted;
